<template>
  <div class>
    <!--=== Header Start ===-->
    <header class="header-navbar sticky-top">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-md-12 px-0 py-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="left-logo edu-banner">
                <a href>
                  <img id="imgBanner" v-bind:src="BannerURL" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="page-effect RegEvent-wrapper edu-rage event_list_reg">
      <section class="reg-event-banner text-center">
        <h1 class="mt-2">Select an Event to Register</h1>
        <!--search box start-->
        <div class="event_Search new_common_search position-relative">
          <input
            v-model="searchText"
            class="search-events-input"
            placeholder="Search events"
            value=""
          />
          <div class="reset-search-btn">
            <p @click="searchText = ''">
              <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
            </p>
          </div>
          <button aria-label="search for events" class="search-submit-button">
            <svg
              width="18"
              height="18"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.25 8.30362L11.9167 10.9735C12.0358 11.106 12.0299 11.3087 11.9033 11.4341L11.4367 11.9013C11.3741 11.9645 11.2889 12 11.2 12C11.1111 12 11.0259 11.9645 10.9633 11.9013L8.29666 9.2314C8.22291 9.1575 8.15597 9.07707 8.09666 8.99111L7.59666 8.32364C6.76937 8.98506 5.74203 9.34518 4.68333 9.34487C2.50174 9.35245 0.606014 7.84573 0.118485 5.71674C-0.369044 3.58774 0.681736 1.40466 2.64873 0.459942C4.61573 -0.484772 6.97398 0.0610084 8.32733 1.77417C9.68068 3.48732 9.66795 5.91064 8.29666 7.60945L8.96333 8.07C9.06744 8.13672 9.16362 8.21509 9.25 8.30362ZM1.35 4.67255C1.35 6.51572 2.84238 8.0099 4.68333 8.0099C5.56739 8.0099 6.41523 7.65829 7.04035 7.03241C7.66548 6.40654 8.01667 5.55767 8.01667 4.67255C8.01667 2.82938 6.52428 1.3352 4.68333 1.3352C2.84238 1.3352 1.35 2.82938 1.35 4.67255Z"
                fill="currentcolor"
              ></path>
            </svg>
          </button>
        </div>
        <!--search box end-->
      </section>
      <section class="event-box-list-wrapper">
        <div class="mx-4">
          <div class="row">
            <div class="col-sm-12 py-0">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="ev_head mb-0">Events</h2>
                <div
                  class="
                    top-right-login
                    hdr-btn
                    text-right
                    d-flex
                    align-items-center
                  "
                >
                  <!--<div class="d-md-none d-block mob_search_button btn p-0"  v-on:click="mob_elist_search()">
					<img src="../assets/Images/icons/search-black.svg" alt="e2m" width="20px">
				</div>-->
                  <!-------->
                  <!-- <div v-show="!isMobileSearch" class="right-search-hld" >
                    <div
                      class="position-relative fixed-w full-width search-hld"
                    >
                      <div
                        id="newsletter-validate-detail"
                        class="form subscribe"
                      >
                        <input
                          v-model="searchText"
                          type="text"
                          placeholder="Search by Name"
                        />
                      </div>
                      <div class="reset-search-btn">
                        <p @click="searchText = ''">
                          Clear<v-icon dark small color="#8a8a8a"
                            >mdi-close</v-icon
                          >
                        </p>
                      </div>
                    </div>
                    <a href="javascript:void(0);" class="px-3">GO</a>
                  </div>-->
                  <!-------->
                  <a
                    data-toggle="modal"
                    data-target="#AdminLoginModalCenter"
                    class="login admin_login"
                    >Login</a
                  >
                </div>
              </div>
              <!--<div id="mob_ev_search" style="display:none">
				<div v-show="isMobileSearch" class="right-search-hld my-3 ">
				<div class="position-relative fixed-w full-width search-hld">
				<div id="newsletter-validate-detail" class="form subscribe">
				<input
				v-model="searchText"
				type="text"
				placeholder="Search by Name"
				/>
				</div>
				<div class="reset-search-btn">
				<p @click="searchText = ''">
				Clear<v-icon dark small color="#8a8a8a">mdi-close</v-icon>
				</p>
				</div>
				</div>
				<a href="javascript:void(0);" class="px-3">GO</a>
				</div>
				</div>-->
            </div>
          </div>
          <div class="row">
            <div class="no-reg-events" v-if="noEventMessage">
              <h3>There are currently no events to Register.</h3>
              <h5 v-if="!noEventLink.includes('campus.edulife')">
                Would you like to setup, and host your own event?
              </h5>
              <a :href="noEventLink"
                ><template v-if="noEventLink.includes('campus.edulife')"
                  >Visit Campus</template
                ><template v-else>Host Your Own Event</template>
              </a>
            </div>
            <div
              v-for="events in SearchEventsData"
              v-bind:key="events.id"
              v-on:click="selectEvent(events.id, events.Name)"
              v-bind:id="events.id"
              class="col-md-4 event_list_box_w"
            >
              <div
                class="ev-box border mb-md-3 mb-0 event-list-register-shimmer"
              >
                <div class="ev-box-image-hld">
                  <div class="shimmer-effect">
                    <photo class="shine"></photo>
                  </div>
                  <img
                    v-bind:src="events.EventLogo"
                    v-bind:alt="events.Name"
                    v-on:load="stopShimmer()"
                  />
                  <h4 class="px-3 mt-3">{{ events.Name }}</h4>
                </div>
                <div class="ev-box-des-hld p-3">
                  <!--<h6>
                  <span>Hosted By:</span>
                  {{ClientName}}
                  </h6>-->
                  <div class="top-right-login">
                    <a href class="event-List evnttime_ico"
                      >{{ events.EventStartDateString }} to
                      {{ events.EventEndDateString }} &nbsp;
                      {{ events.EventTimezone }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Admin Login Modal -->
    <div
      class="modal fade admin-login-modal"
      id="AdminLoginModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body position-relative">
            <div class="admin-login-section-wrap d-none">
              <div>
                <h2>Log in</h2>
                <p>Don't have an account yet? <a href="">sign up</a></p>
              </div>
              <div class="d-none">
                <h2>
                  Create<br />
                  your account
                </h2>
                <p>
                  Already have an account? <a href=""><u>sign in</u></a>
                </p>
              </div>
              


              <div class="social-login-section d-none">
                <div class="single-social">
                  <img src="../assets/Images/microsoft.png" />
                  <p>Microsoft</p>
                </div>
                <div class="single-social">
                  <img src="../assets/Images/google-login-icon.png" />
                  <p>Google</p>
                </div>
                <div class="single-social">
                  <img src="../assets/Images/linked-in.png" />
                  <p>Google</p>
                </div>
              </div>
              <div class="or-div mt-4 mb-2">
                <p>or continue with</p>
              </div>
              <div class="admin-login-field-wrap">
                <label>Email<span>*</span></label>
                <input
                  type="text"
                  name=""
                  id=""
                  value=""
                  placeholder="Enter email"
                />

                <label>Password<span>*</span></label>
                <input
                  type="password"
                  name=""
                  id=""
                  value=""
                  placeholder="Enter password"
                />
                <a href="" class="forgot-pwd">Forgot Password?</a>
                <input type="submit" value="Log in" />
              </div>
              <div class="admin-signup-field-wrap d-none">
                <ul class="d-flex justify-content-between align-items-center">
                  <li class="mr-2">
                    <label>First Name</label>
                    <input type="text" name="" id="" value="" />
                  </li>
                  <li class="ml-2">
                    <label>Last Name</label>
                    <input type="text" name="" id="" value="" />
                  </li>
                </ul>

                <label>Email Address</label>
                <input type="email" name="" id="" value="" />

                <label>Password</label>
                <input type="password" name="" id="" value="" />

                <input type="submit" value="Continue" />
              </div>
              <p class="terms-conditions">
                By signing in, I agree to the <a href="">privacy policy</a> and
                <a href="">Terms of service</a>.
              </p>
            </div>

            <div class="admin-login-close-button">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="reg-success-sec my-8">
              <div class="reg-success-box-hld">
                <h3>Welcome!</h3>
                <p class="mt-0">
                  Thanks for signing up! We just need you to verify your email
                  address to complete setting up your account.
                </p>
              </div>
              <div
                class="d-flex justify-content-center align-items-center mt-5"
              >
                <v-btn dark color="#1a73e8"
                  ><v-icon dark color="#fff" size="20px" class="mr-1"
                    >mdi-email-outline</v-icon
                  >
                  Verify My Email</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
// import firebase from "firebase";
// import axios from "axios";
// import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
Vue.use(VueMoment, {
  moment,
});
export default {
  data() {
    return {
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      searchText: "",
    };
  },
  computed: {
    SearchEventsData() {
      var result = [];
      if (!self.searchText) {
        result = self.EventsData.filter(function () {
          return true;
        });
      } else {
        self.EventsData.map(function (item) {
          if (item.Name.toLowerCase().includes(self.searchText.toLowerCase())) {
            result.push(item);
          }
        });
      }
      return result;
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
  },
  created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
  },
  mounted() {
    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.query.c;
    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    //debugger;
    $("#topmenu").hide();
    $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //this.result = "uatonair.e2m.live";
      //self.hostName = "onair.e2m.live";
      self.hostName = HOSTURL ? HOSTURL : "uatonair.e2m.live";
      // self.hostName = "uatbni.e2m.live";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
      //self.hostName = location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        //debugger;
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        //debugger;
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(self.clientID)
          .get()
          .then(function (doc) {
            var data = doc.data();
            console.log(data);
            //debugger;
            self.clientLogoUrl = data.LoginAssets.logo;
            self.ClientName = data.ClientName;
            self.clientProfile = data.Company;

            self.desktopBanner = data.EventListAssets.banner2048x88;
            self.mobileBanner = data.EventListAssets.banner750x103;
            //  self.BannerURL = data.EventListAssets.banner640x88;
            self.initScreen();
          });
        self.EventsData = [];
        self.displayEvents();
      });

    //------------------------------------------------------------------------------------

    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

    $("#imgBanner").attr("src", self.BannerURL);
  },
  methods: {
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },
    displayEvents() {
      //debugger;
      this.pageIndex++;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      var cnt = 0;
      listRef
        //.where("IsPublished", "==", true)
        //.where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          debugger;
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              cnt++;
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, hh:MM TT");
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(dtend, "mmm dd, hh:MM TT"); // self.formatDate(data.EventEndDate);
              obj.EventStartDate = data.EventStartDate;
              obj.EventEndDate = data.EventEndDate;
              //------------------------------------------------------------------------------------------------
              self.EventsData.push(obj);
            });
            //debugger;
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            self.EventsData = self.EventsData.sort(function compare(a, b) {
              //debugger;
              //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
              var dateA = parseInt(
                new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
              );
              var dateB = parseInt(
                new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
              );
              return dateB - dateA;
            });
            if (cnt == 1) {
              //debugger;
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/event/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        //debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      console.log("evntName:--- " + evntName);
      router.push({
        path: "/event/" + eventId,
      });
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    /* ,
    computed: {
      BannerURL() {
        // debugger;
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>
